import { createSlice } from '@reduxjs/toolkit';
import {
  AddAssemblyStageOneList,
  AddAssemblyStageThreeList,
  fetchAssemblyStageOneForm,
  fetchAssemblyStageOneList,
  fetchAssemblyStageThreeFlowHistory,
  fetchAssemblyStageThreeFormList,
  fetchAssemblyStageThreeList,
  getShellNumber,
} from './assemblyThunk';

const initialState = {
  assemblyStageOne: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  addAssemblyStageOne: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  listAssemblyStageOne: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  assemblyStageThree: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  shellNo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  addAssemblyStageThree: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getAssemblyStageThree: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
};

const assemblySlice = createSlice({
  name: 'assembly',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssemblyStageOneForm.pending, (state) => {
        state.assemblyStageOne.loading = true;
        state.assemblyStageOne.error = null;
      })
      .addCase(fetchAssemblyStageOneForm.fulfilled, (state, action) => {
        state.assemblyStageOne.loading = false;
        state.assemblyStageOne.data = action.payload;
      })
      .addCase(fetchAssemblyStageOneForm.rejected, (state, action) => {
        state.assemblyStageOne.loading = false;
        state.assemblyStageOne.error = action.payload || 'Failed to fetch Assembly';
      })
      .addCase(fetchAssemblyStageOneList.pending, (state) => {
        state.listAssemblyStageOne.loading = true;
        state.listAssemblyStageOne.error = null;
      })
      .addCase(fetchAssemblyStageOneList.fulfilled, (state, action) => {
        state.listAssemblyStageOne.loading = false;
        state.listAssemblyStageOne.data = action.payload;
        state.pagination = {
          total: action.payload.total,
          per_page: action.payload.per_page,
          current_page: action.payload.current_page,
          last_page: action.payload.last_page,
        };
      })
      .addCase(fetchAssemblyStageOneList.rejected, (state, action) => {
        state.listAssemblyStageOne.loading = false;
        state.listAssemblyStageOne.error = action.payload || 'Failed to fetch Assembly';
      })
      .addCase(AddAssemblyStageOneList.pending, (state) => {
        state.addAssemblyStageOne.loading = true;
        state.addAssemblyStageOne.error = null;
      })
      .addCase(AddAssemblyStageOneList.fulfilled, (state, action) => {
        state.addAssemblyStageOne.loading = false;
        state.addAssemblyStageOne.data = action.payload;
      })
      .addCase(AddAssemblyStageOneList.rejected, (state, action) => {
        state.addAssemblyStageOne.loading = false;
        state.addAssemblyStageOne.error = action.payload || 'Failed to fetch Assembly';
      })

      .addCase(fetchAssemblyStageThreeFormList.pending, (state) => {
        state.assemblyStageThree.loading = true;
        state.assemblyStageThree.error = null;
      })
      .addCase(fetchAssemblyStageThreeFormList.fulfilled, (state, action) => {
        state.assemblyStageThree.loading = false;
        state.assemblyStageThree.data = action.payload;
      })
      .addCase(fetchAssemblyStageThreeFormList.rejected, (state, action) => {
        state.assemblyStageThree.loading = false;
        state.assemblyStageThree.error = action.payload || 'Failed to fetch Assembly';
      })

      .addCase(getShellNumber.pending, (state) => {
        state.shellNo.loading = true;
        state.shellNo.error = null;
      })
      .addCase(getShellNumber.fulfilled, (state, action) => {
        state.shellNo.loading = false;
        state.shellNo.data = action.payload;
      })
      .addCase(getShellNumber.rejected, (state, action) => {
        state.shellNo.loading = false;
        state.shellNo.error = action.payload || 'Failed to fetch Assembly';
      })

      .addCase(AddAssemblyStageThreeList.pending, (state) => {
        state.addAssemblyStageThree.loading = true;
        state.addAssemblyStageThree.error = null;
      })
      .addCase(AddAssemblyStageThreeList.fulfilled, (state, action) => {
        state.addAssemblyStageThree.loading = false;
        state.addAssemblyStageThree.data = action.payload;
      })
      .addCase(AddAssemblyStageThreeList.rejected, (state, action) => {
        state.addAssemblyStageThree.loading = false;
        state.addAssemblyStageThree.error = action.payload || 'Failed to fetch Assembly';
      })

      .addCase(fetchAssemblyStageThreeList.pending, (state) => {
        state.getAssemblyStageThree.loading = true;
        state.getAssemblyStageThree.error = null;
      })
      .addCase(fetchAssemblyStageThreeList.fulfilled, (state, action) => {
        state.getAssemblyStageThree.loading = false;
        state.getAssemblyStageThree.data = action.payload;
        state.pagination = {
          total: action.payload.total,
          per_page: action.payload.per_page,
          current_page: action.payload.current_page,
          last_page: action.payload.last_page,
        };
      })
      .addCase(fetchAssemblyStageThreeList.rejected, (state, action) => {
        state.getAssemblyStageThree.loading = false;
        state.getAssemblyStageThree.error = action.payload || 'Failed to fetch Assembly';
      })
      .addCase(fetchAssemblyStageThreeFlowHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAssemblyStageThreeFlowHistory.fulfilled, (state, action) => {
        state.flowHistory = action.payload.data || [];
      })
      .addCase(fetchAssemblyStageThreeFlowHistory.rejected, (state, action) => {
        state.loading = false;
        state.flowHistory = action.payload.data;
      });
  },
});
export default assemblySlice.reducer;
